<mat-card-header>
  <div style="width:90%">
    <mat-card-title>Adiantamentos do fornecedor</mat-card-title>
  </div>
  <div style="width:10%; cursor:pointer;">
    <mat-icon class="btnCancel" style="position: relative; float: right; margin-right: 5px" (click)="closePopup()">cancel</mat-icon>
  </div>

</mat-card-header>
<mat-card-content style="width: 600px">
  <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
    <div style="padding: 0px !important; width: 100%">
      <div class="table-container">
        <table mat-table [dataSource]="dataSource" style="width: 100%">

          <!-- Position Column -->
          <ng-container matColumnDef="checked">
            <th mat-header-cell *matHeaderCellDef> Check </th>
            <td mat-cell *matCellDef="let element">
              <mat-checkbox [(ngModel)]="element.checked"></mat-checkbox>
            </td>
          </ng-container>

          <!-- descMensagem Column -->
          <ng-container matColumnDef="numSolAdiantamento">
            <th mat-header-cell *matHeaderCellDef> Tipo de Adiantamento </th>
            <td mat-cell *matCellDef="let element"> {{element.numSolAdiantamento}} </td>
          </ng-container>

          <!-- descMensagem Column -->
          <ng-container matColumnDef="referencia">
            <th mat-header-cell *matHeaderCellDef> Descrição </th>
            <td mat-cell *matCellDef="let element"> {{element.referencia}} </td>
          </ng-container>

          <!-- descMensagem Column -->
          <ng-container matColumnDef="montante">
            <th mat-header-cell *matHeaderCellDef> Valor (R$) </th>
            <td mat-cell *matCellDef="let element"> {{element.montante}} </td>
          </ng-container>

          <!-- descMensagem Column -->
          <ng-container matColumnDef="descDivisao">
            <th mat-header-cell *matHeaderCellDef> Divisão </th>
            <td mat-cell *matCellDef="let element"> {{element.descDivisao}} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
      <mat-paginator [pageSizeOptions]="[5, 50, 100, 500, 1000]" showFirstLastButtons></mat-paginator>
    </div>
  </div>
</mat-card-content>
<mat-action-row class="footer">
  <button id="btnTipoDoc" mat-button color="primary" class="btn-primary" (click)="VincularAdiantamentos()">VINCULAR</button>
</mat-action-row>